module.exports = __webpack_public_path__ + "static/img/airoad_bg.707198f7.png";